import { Component, OnInit } from '@angular/core';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-monthly-charges',
  templateUrl: './monthly-charges.component.html',
  styleUrls: ['./monthly-charges.component.scss']
})
export class MonthlyChargesComponent implements OnInit {
  reportSection: boolean;

  constructor(private _Activatedroute: ActivatedRoute) { }

  ngOnInit() {
    this._Activatedroute.queryParams.subscribe(params => {
      this.reportSection = params['reportSection'];
    });
  }

}
